import React from "react";

function ContactPage() {
  return (
    <>
      <div>
        <h1 className="text-black">Contact Page</h1>
        <p>
          Hello and thank you for getting intouch, please use the form below to
          reach out.
        </p>
        <form className="w-50">
          <div className="pt-5 mb-3">
            <label for="exampleInputEmail1" className="form-label">
              Email address
            </label>
            <input
              type="email"
              className="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
            />
          </div>
          <div className="mb-3">
            <label for="exampleInputPassword1" className="form-label">
              Password
            </label>
            <input
              type="password"
              className="form-control"
              id="exampleInputPassword1"
            />
          </div>
          <div className="mb-3">
            <p>Please tell me what you are getting in touch for.</p>
          </div>
          <div className="mb-3 form-check">
            <input
              type="checkbox"
              className="form-check-input border-primary"
              id="Job Offer"
            />
            <label className="form-check-label" for="Job Offer">
              Job Offer
            </label>
          </div>
          <div className="mb-3 form-check">
            <input
              type="checkbox"
              className="form-check-input border-primary"
              id="Project Request"
            />
            <label className="form-check-label" for="Project Request">
              Project Request
            </label>
          </div>
          <div className="mb-3 form-check">
            <input
              type="checkbox"
              className="form-check-input border-primary"
              id="Query"
            />
            <label className="form-check-label" for="JQuery">
              Query
            </label>
          </div>
          <button type="submit" className="btn btn-primary">
            Submit
          </button>
        </form>
      </div>
    </>
  );
}

export default ContactPage;
